import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import {
  GENERAL_STORE, EDITOR_TIMELINE_STORE,
  EDITOR_STORE, ModalComponentKeyTypes, PROJECT_STORE
} from 'store'
import {
  PopupContainer, ModalLocationInput,
  ConfirmDialog, ProjectsFilter, HotkeysList
} from 'components'

const ModalDialogComponent = props => {
  const {
    [GENERAL_STORE]: {
      modalDialogDetails,
      hideModalDialog
    },
    [PROJECT_STORE]: {
      republishProject,
    }
  } = props

  const getComponent = () => {
    switch (modalDialogDetails.componentKey) {
      case ModalComponentKeyTypes.LOCATION_INPUT:
        return ModalLocationInput

      case ModalComponentKeyTypes.CONFIRM_DIALOG:
        return ConfirmDialog

      case ModalComponentKeyTypes.PROJECTS_FILTER:
        return ProjectsFilter

      case ModalComponentKeyTypes.HOTKEYS_LIST:
        return HotkeysList

      default: return null
    }
  }

  const { show, title, description, onSubmit, submitText, project } = modalDialogDetails
  const Component = getComponent()

  useEffect(() => {
    const handleEscKey = e => {
      const isEscKeyPressed = e.which === 27
      isEscKeyPressed && hideModalDialog()
    }

    show && window.addEventListener('keydown', handleEscKey)
    return () => window.removeEventListener('keydown', handleEscKey)
  }, [show, hideModalDialog])

  return show
    ? (
      <PopupContainer
        size='small'
        title={title}
        onClose={hideModalDialog}
      >
        <Component
          {...{
            description,
            submitText,
            project,
            onSubmit,
            closeModal: hideModalDialog,
            republishProject,
          }}
        />
      </PopupContainer>
    )
    : null
}

const ModalDialog = inject(
  GENERAL_STORE,
  EDITOR_TIMELINE_STORE,
  EDITOR_STORE,
  PROJECT_STORE
)(observer(ModalDialogComponent))
export default ModalDialog
